import React from 'react';
import * as assetActions from '../../../redux/actions/assetsAction';
import { useDispatch, useSelector } from 'react-redux';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { Asset } from '../../../Utils/AssetUtils';
import { Button, TextField, Tooltip } from '@material-ui/core';
import TabHeader from '../../common/TabHeader';

const title = 'Manual Entry';
const explanation = `To upload models, first select how many assets you need to create. Upon adding assets, you can then drag & drop models to each of the assets you create. Once you're done, press the "Next" button to add information to each asset or skip directly to "Review & Create" to complete the creation of your assets.`;
const addAssetBtnTxt = 'Add Assets';
const quantityDefaultValue = 1;
const quantityMaxLimitValue = 10;
const addAssetsBtnToolTip = 'Click to add assets to the table below.';

const AssetManualEntry = () => {
	const assets = useSelector((state) => state.assets);
	const dispatch = useDispatch();
	//making first step active by default (upload files)
	const [quantityVal, setQuantityVal] = React.useState(quantityDefaultValue);

	const quantityFieldKeyPressHandler = (event, value) => {
		if (event.target.validity.valid) {
			setQuantityVal(parseInt(event.target.value, quantityMaxLimitValue));
		} else {
			setQuantityVal(quantityDefaultValue);
		}
	};

	const createAssetBtnOnClickHandler = (event, value) => {
		const newAssets = [];
		const assetsLength = assets.length;
		const assetsLastIndex = assets[assetsLength - 1] ? assets[assetsLength - 1].id : 0;
		//Creating asset containers when create button is clicked
		for (let index = 1; index <= quantityVal; index++) {
			const id = assetsLastIndex + index;
			const asset = new Asset(id);
			newAssets.push(asset);
		}
		dispatch(assetActions.addAssets(newAssets));
	};
	const actions = [
		<React.Fragment>
			<TextField
				variant="outlined"
				type="number"
				value={quantityVal}
				onChange={quantityFieldKeyPressHandler}
				data-cy="asset-quantity-textBox"
				size="small"
				inputProps={{
					min: 1,
					step: 1,
					max: quantityMaxLimitValue,
					pattern: '[0-9]*',
				}}
			/>
			<Tooltip title={addAssetsBtnToolTip} arrow={true} placement="top">
				<Button
					variant="contained"
					color="primary"
					data-cy="manual-add-asset-btn"
					onClick={createAssetBtnOnClickHandler}
					startIcon={<AddCircleOutlineIcon fontSize="small" />}
				>
					{addAssetBtnTxt}
				</Button>
			</Tooltip>
		</React.Fragment>,
	];
	return (
		<TabHeader
			title={title}
			explanation={explanation}
			explanationDataCy="upload-files-content-msg"
			actions={actions}
		/>
	);
};
export default AssetManualEntry;
